export default "__VITE_ASSET__BVWqqDqz__"